import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType ,HttpHeaders} from '@angular/common/http';
import { TokenService } from '../../../app/token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class AdminstrationService {

  httpUrl;

  constructor(private http: HttpClient, private main: MainService,private token:TokenService) {
    this.httpUrl = this.main.httpUrl;
  }
  // async getAllPropHierarchy(obj :any) {
  //   console.log('called')
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/property/propHier/getAllpropHierarchy' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async insertPropHierarchyNode(obj :any) {
  //   const resp = await this.http.post<any>(this.main.httpUrl + '/property/propHier/insertpropHierarchyNode' , obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async updatePropHierarchyNode(obj :any) {
  //   const resp = await this.http.put<any>(this.main.httpUrl + '/property/propHier/updatepropHierarchyNode' , obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async getuserAssigneddata(obj :any) {
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/icms/icmsdataAssign/getuserAssigneddata' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // *****************************************************************************************
  async getUSTPAssigneddata2(obj :any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/noc/dataassigment/getnocAssigned' + obj, { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertRoleAuthorization(obj :any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/noc/dataassigment/insertNOCdataAssign' , obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateRoleAuthorization(obj :any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/noc/dataassigment/updatenocdataAssign' , obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
